<div class="wrap">
  <h3>Liaison du compte</h3>
  <form [formGroup]="checkLicenceForm" (ngSubmit)="onSubmit()">
    <div class="form_group">
      <label for="mail">Adresse mail liée à la licence</label>
      <input type="mail" formControlName="mail">
    </div>
    <div class="form_group">
      <label for="licence">Numéro de licence</label>
      <input type="text" formControlName="licence">
    </div>

    <div class="btn_action">
      <button (click)="back()" type="button" class="no">Annuler</button>
      <button [disabled]="loading" type="submit">Lier</button>
    </div>
  </form>

</div>